<template>
  <div class="row">
    <div class="col-md-12">
      <div class="discount-text">
        <h4>{{ $t("message.set_discount") }}:</h4>
      </div>
    </div>

    <!-- <div class="col-md-6">
      <div class="discount-slider">
        <vue-slider ref="slider" v-model="discount"
        :max="99"
        :dot-size="24"
        :tooltip=false
        :style=slider.style
        :processStyle=slider.processStyle
        :sliderStyle=slider.sliderStyle
        :bgStyle=slider.bgStyle
        @drag-start="dragStart()"
        @drag-end="dragEnd()"
        @callback="callback()"
        />
      </div>
    </div>-->

    <div class="col-md-8">
      <div class="discount-value">
        <div class="input-group">
          <input type="text" class="form-control" @keyup="input_change()" v-model="discount">
          <!--<div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
          -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vueSlider from "vue-slider-component";
export default {
  components: {
    vueSlider
  },
  data() {
    return {
      msg: "Discount",
      discount: 0,
      slider: {
        style: {},
        bgStyle: {
          background: "#f1f1f1"
        },
        sliderStyle: {
          backgroundColor: "#fff",
          boxShadow: "none",
          border: "3px solid #23497f"
        },
        processStyle: {
          backgroundColor: "#23497f"
        },
        isHoldOrMove: false // custom - when holding the ball or moving it
      }
    };
  },
  methods: {
    dragStart() {
      this.slider.isHoldOrMove = true;
    },
    dragEnd() {
      this.slider.isHoldOrMove = false;
      this.$store.dispatch("pricelist/set_discount", this.discount);
    },
    callback() {
      // there's no need to each time set the discount - only when click on bar
      if (!this.slider.isHoldOrMove) {
        this.$store.dispatch("pricelist/set_discount", this.discount);
      }
    },
    input_change() {
      let min = 0;
      let max = 99;
      let discount = parseInt(this.discount);
      if (isNaN(discount)) {
        discount = 0;
        this.$store.dispatch("pricelist/set_discount", discount);
        return;
      }
      discount =
        this.discount < min ? min : this.discount > max ? max : discount;
      this.$store.dispatch("pricelist/set_discount", discount);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.discount-text {
  h4 {
    font-size: 0.8em;
    text-align: center;
    @media (min-width: 768px) {
      text-align: left;
      font-size: 1em;
    }
  }
}
.discount-slider {
  padding: 3.75px 0;
}
.discount-value {
  text-align: center;
  @media (min-width: 992px) {
    text-align: left;
  }
  .input-group-text {
    background: #f1f1f1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Discount/Discount.vue